export const FUTBOL_LIBERTADORES_MATCHES = [
  {
    team1: 'flamengo',
    team2: 'racing club',
    day: 'Miércoles - en vivo',
    time1: '21:30',
    time2: '20:30',
    time3: '19:30',
    region1: 'arg/cl',
    region2: 'bo',
    region3: 'co',
    channel: 'disney+',
    tournament: 'conmebol-libertadores',
    date: '2025-10-22'
  },
  {
    team1: 'liga de quito',
    team2: 'palmeiras',
    day: 'Jueves - en vivo',
    time1: '21:30',
    time2: '20:30',
    time3: '19:30',
    region1: 'arg/cl',
    region2: 'bo',
    region3: 'co',
    channel: 'disney+',
    tournament: 'conmebol-libertadores',
    date: '2025-10-23'
  },
  {
    team1: 'racing club',
    team2: 'flamengo',
    day: 'Miércoles - en vivo',
    time1: '21:30',
    time2: '20:30',
    time3: '19:30',
    region1: 'arg/cl',
    region2: 'bo',
    region3: 'co',
    channel: 'disney+',
    tournament: 'conmebol-libertadores',
    date: '2025-10-29'
  },
  {
    team1: 'palmeiras',
    team2: 'liga de quito',
    day: 'Jueves - en vivo',
    time1: '21:30',
    time2: '20:30',
    time3: '19:30',
    region1: 'arg/cl',
    region2: 'bo',
    region3: 'co',
    channel: 'disney+',
    tournament: 'conmebol-libertadores',
    date: '2025-10-30'
  }
];
